import React, { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import {
  Button,
  FormGroup,
  Input as ReactstrapInput,
  Label,
  Row,
  Col,
  InputGroupAddon,
} from "reactstrap";
import {
  Colxx,
  Separator,
} from "../../../../components/common/CustomBootstrap";
import IntlMessages from "../../../../helpers/IntlMessages";
import axios from "axios";
import { END_POINT } from "../../../../constants/defaultValues";
import {
  AddCommaNumber,
  NotificatioErrController,
} from "../../../../helpers/Utils";
import CustomSelectInput from "../../../../components/common/CustomSelectInput";
import { NormalizeIntegerInput } from "../../../../helpers/NumberInput";

export const PromotionNumericInput = ({ onChange, ...props }) => {
  const handleChange = (event) => {
    if (!onChange) return;

    event.target.value = NormalizeIntegerInput(event.target.value);
    onChange(event);
  };

  return (
    <ReactstrapInput
      {...props}
      type="text"
      inputMode="numeric"
      onChange={handleChange}
    />
  );
};

const Input = PromotionNumericInput;

const fetchProductFromAPI = () => {
  let tokenStr = localStorage.getItem("access_token");
  return axios
    .get(END_POINT + "/product/all", {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
    .then((res) => res.data)
    .catch((err) => {
      NotificatioErrController(err.response.data.responseText);
      return false;
    });
};

const fetchCategoriesFromAPI = () => {
  let tokenStr = localStorage.getItem("access_token");
  return axios
    .get(END_POINT + "/category", {
      headers: { Authorization: `Bearer ${tokenStr}` },
    })
    .then((res) => res.data)
    .catch((err) => {
      NotificatioErrController(err.response.data.responseText);
      return false;
    });
};

export const CustomOptionComponentDiscount = ({
  values,
  selectedOption,
  onChangeItem,
  onAddItem,
  onAddProduct,
  onRemoveDiscount,
  onRemoveProduct,
  discountRange,
  oneProduct,
  oneTypeProduct,
  quantityProduct,
  quantityTypeProduct,
  customerPoint,
  customerGroupDiscount,
  firstOrderDiscount,
}) => {
  // console.log('oneProduct', oneProduct);
  const [products, setProducts] = useState(null);
  const [categories, setCategories] = useState(null);

  useEffect(() => {
    fetchProductFromAPI().then((data) => {
      setProducts(data);
    });
    fetchCategoriesFromAPI().then((data) => {
      setCategories(data);
    });
  }, []);

  const products_discount = products?.data?.map(({ options: _opts, ...d }) => ({
    label: d.name,
    value: d.name,
    ...d,
  })) || [];

  const categories_discount = categories?.data?.map(({ options: _opts, ...c }) => ({
    label: c.name,
    value: c.name,
    ...c,
  })) || [];

  const customer_group_discount = [
    { label: "Hạng Đồng", value: "Đồng" },
    { label: "Hạng Bạc", value: "Bạc" },
    { label: "Hạng Vàng", value: "Vàng" },
    { label: "Hạng Kim Cương", value: "Kim Cương" },
  ];

  const AddMoreButton = ({ category, onAddItem }) => {
    return (
      <Row className="pt-4">
        <Col sm={12} xs={12} md={12} lg={12}>
          <span
            className="working_hours_btn working_hours_btn-zero-top mb-3 disable-text-selection"
            onClick={() => onAddItem(category)}
          >
            +
          </span>
        </Col>
      </Row>
    );
  };

  if (selectedOption === "total-order-value") {
    return (
      <>
        {discountRange?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "discountRange")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="6" className="pr-1">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="price_start">
                      Đơn hàng từ: <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      name="price_start"
                      id="price_start"
                      value={AddCommaNumber(range.price_start)}
                      onChange={(e) =>
                        onChangeItem("discountRange", idx, "price_start", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
                <Colxx xxs="6" className="pl-1">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="price_end">
                      đến: <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      name="price_end"
                      id="price_end"
                      value={AddCommaNumber(range.price_end)}
                      onChange={(e) =>
                        onChangeItem("discountRange", idx, "price_end", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  inputMode="numeric"
                  name="discount_value"
                  id="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("discountRange", idx, "discount_value", e)
                  }
                  className="mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("discountRange", idx, "discount_type", e)
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("discountRange", idx, "discount_type", e)
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("discountRange", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="discountRange" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "one-product") {
    return (
      <>
        {oneProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "oneProduct")}
                />
              </div>
              <div className="position-relative mb-3">
                {/* <FormGroup className='has-float-label'> */}
                {range?.product?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="product">
                            Chọn sản phẩm{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="product"
                            placeholder={
                              <IntlMessages id="discount.select-one-product" />
                            }
                            options={products_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "oneProduct",
                                idx,
                                "product",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="quantity">
                            Số lượng <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "oneProduct",
                                idx,
                                "quantity_product",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(idx, index, "oneProduct", "product")
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() => onAddProduct(idx, "oneProduct", "product")}
                />
                {/* </FormGroup> */}
              </div>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("oneProduct", idx, "discount_value", e)
                  }
                  name="discount_value"
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={() =>
                      onChangeItem("oneProduct", idx, "discount_type", 1)
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={() =>
                      onChangeItem("oneProduct", idx, "discount_type", 2)
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("oneProduct", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="oneProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "one-type-product") {
    return (
      <>
        {oneTypeProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "oneTypeProduct")}
                />
              </div>
              <div className="position-relative mb-3">
                {range?.category?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="category">
                            Chọn danh mục sản phẩm{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="type"
                            placeholder={
                              <IntlMessages id="discount.select-one-type-product" />
                            }
                            options={categories_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "oneTypeProduct",
                                idx,
                                "category",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="quantity">
                            Số lượng <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "oneTypeProduct",
                                idx,
                                "quantity_category",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(
                            idx,
                            index,
                            "oneTypeProduct",
                            "category"
                          )
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() =>
                    onAddProduct(idx, "oneTypeProduct", "category")
                  }
                />
              </div>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("oneTypeProduct", idx, "discount_value", e)
                  }
                  className="mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    className="border-radius-topbot-left"
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("oneTypeProduct", idx, "discount_type", e)
                    }
                    active={range.discount_type === 1}
                  >
                    VNĐ
                  </Button>
                  <Button
                    className="border-radius-topbot-right"
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("oneTypeProduct", idx, "discount_type", e)
                    }
                    active={range.discount_type === 2}
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("oneTypeProduct", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="oneTypeProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "quantity-product") {
    return (
      <>
        {quantityProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "quantityProduct")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="12">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="quantity">
                      Số lượng sản phẩm cần mua{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      inputMode="numeric"
                      name="quantity"
                      value={range.quantity}
                      onChange={(e) =>
                        onChangeItem("quantityProduct", idx, "quantity", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("quantityProduct", idx, "discount_value", e)
                  }
                  name="discount_value"
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("quantityProduct", idx, "discount_type", e)
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("quantityProduct", idx, "discount_type", e)
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("quantityProduct", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="quantityProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "quantity-type-product") {
    return (
      <>
        {quantityTypeProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "quantityTypeProduct")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="12">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="quantity_type_product">
                      Số lượng danh mục sản phẩm{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      inputMode="numeric"
                      name="quantity_type_product"
                      value={range.quantity_type_product}
                      onChange={(e) =>
                        onChangeItem(
                          "quantityTypeProduct",
                          idx,
                          "quantity_type_product",
                          e
                        )
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem(
                      "quantityTypeProduct",
                      idx,
                      "discount_value",
                      e
                    )
                  }
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "quantityTypeProduct",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "quantityTypeProduct",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("quantityTypeProduct", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="quantityTypeProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "customer-accrual-points") {
    return (
      <>
        {customerPoint?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "customerPoint")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="12">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="customer_point">
                      Mốc tích điểm <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="text"
                      name="customer_point"
                      value={range.customer_point}
                      onChange={(e) =>
                        onChangeItem("customerPoint", idx, "customer_point", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("customerPoint", idx, "discount_value", e)
                  }
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("customerPoint", idx, "discount_type", e)
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem("customerPoint", idx, "discount_type", e)
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem("customerPoint", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="customerPoint" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "customer-group-discount") {
    return (
      <>
        {customerGroupDiscount?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "customerGroupDiscount")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="12">
                  <FormGroup className="has-float-label">
                    <Label
                      className="text-muted"
                      for="customer_point_milestone"
                    >
                      Chọn nhóm khách hàng{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Select
                      components={{
                        Input: CustomSelectInput,
                      }}
                      className="react-select pb-1"
                      classNamePrefix="react-select"
                      name="type"
                      placeholder={
                        <IntlMessages id="discount.select-one-type-product" />
                      }
                      options={customer_group_discount}
                      onChange={(e) =>
                        onChangeItem(
                          "customerGroupDiscount",
                          idx,
                          "customer_point_milestone",
                          e
                          // index
                        )
                      }
                      value={range}
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem(
                      "customerGroupDiscount",
                      idx,
                      "discount_value",
                      e
                    )
                  }
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "customerGroupDiscount",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "customerGroupDiscount",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount)}
                  onChange={(e) =>
                    onChangeItem(
                      "customerGroupDiscount",
                      idx,
                      "max_discount",
                      e
                    )
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="customerGroupDiscount" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "first-order-discount") {
    return (
      <>
        {firstOrderDiscount?.map((range, idx) => {
          // console.log('range', range);
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "firstOrderDiscount")}
                />
              </div>
              <FormGroup className="has-float-label w-100 d-flex">
                <Label className="text-muted" for="discount_value">
                  Mức giảm <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  type="text"
                  name="discount_value"
                  value={AddCommaNumber(range.discount_value)}
                  onChange={(e) =>
                    onChangeItem("firstOrderDiscount", idx, "discount_value", e)
                  }
                  className="grow-1 mr-2"
                />
                <InputGroupAddon addonType="append">
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "firstOrderDiscount",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 1}
                    className="border-radius-topbot-left"
                  >
                    VNĐ
                  </Button>
                  <Button
                    color="primary"
                    outline
                    onClick={(e) =>
                      onChangeItem(
                        "firstOrderDiscount",
                        idx,
                        "discount_type",
                        e
                      )
                    }
                    active={range.discount_type === 2}
                    className="border-radius-topbot-right"
                  >
                    %
                  </Button>
                </InputGroupAddon>
              </FormGroup>
              <FormGroup className="has-float-label">
                <Label className="text-muted" for="max_discount">
                  Giảm tối đa (VNĐ)
                </Label>
                <Input
                  disabled={range.discount_type === 1 ? true : false}
                  type="text"
                  name="max_discount"
                  id="max_discount"
                  value={AddCommaNumber(range.max_discount || "")}
                  onChange={(e) =>
                    onChangeItem("firstOrderDiscount", idx, "max_discount", e)
                  }
                />
              </FormGroup>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="firstOrderDiscount" onAddItem={onAddItem} />
      </>
    );
  }

  // Return null for unhandled cases to prevent React crash
  return null;
};

export const CustomOptionComponentGift = ({
  selectedOption,
  productGetProduct,
  orderGetProduct,
  customerPointGetProduct,
  onAddItem,
  onAddProduct,
  onRemoveDiscount,
  onRemoveProduct,
  onChangeItem,
}) => {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    fetchProductFromAPI().then((data) => {
      setProducts(data);
    });
  }, []);

  const products_discount = products?.data?.map(({ options: _opts, ...d }) => ({
    label: d.name,
    value: d.name,
    ...d,
  })) || [];

  const AddMoreButton = ({ category, onAddItem }) => {
    return (
      <Row className="pt-4">
        <Col sm={12} xs={12} md={12} lg={12}>
          <span
            className="working_hours_btn working_hours_btn-zero-top mb-3 disable-text-selection"
            onClick={() => onAddItem(category)}
          >
            +
          </span>
        </Col>
      </Row>
    );
  };

  if (selectedOption === "product-get-product") {
    return (
      <>
        {productGetProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "productGetProduct")}
                />
              </div>
              <div className="position-relative mb-3">
                {range?.pgp_buy?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="product_buy">
                            Sản phẩm mua
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="product_buy"
                            placeholder={
                              <IntlMessages id="discount.select-one-product" />
                            }
                            options={products_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "productGetProduct",
                                idx,
                                "pgp_buy",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="quantity_pgp_buy">
                            Số lượng
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity_pgp_buy"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "productGetProduct",
                                idx,
                                "quantity_pgp_buy",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(
                            idx,
                            index,
                            "productGetProduct",
                            "pgp_buy"
                          )
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() =>
                    onAddProduct(idx, "productGetProduct", "pgp_buy")
                  }
                />
              </div>
              <div className="position-relative mb-3">
                {range?.pgp_gift?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="product_gift">
                            Sản phẩm tặng
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="product_gift"
                            placeholder={
                              <IntlMessages id="discount.select-one-product" />
                            }
                            options={products_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "productGetProduct",
                                idx,
                                "pgp_gift",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="quantity_pgp_gift">
                            Số lượng
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity_pgp_gift"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "productGetProduct",
                                idx,
                                "quantity_pgp_gift",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(
                            idx,
                            index,
                            "productGetProduct",
                            "pgp_gift"
                          )
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() =>
                    onAddProduct(idx, "productGetProduct", "pgp_gift")
                  }
                />
              </div>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="productGetProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "total-order-value-get-product") {
    return (
      <>
        {orderGetProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() => onRemoveDiscount(idx, "orderGetProduct")}
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="6" className="pr-1">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="price_start">
                      Đơn hàng từ...
                    </Label>
                    <Input
                      type="text"
                      name="price_start"
                      id="price_start"
                      value={AddCommaNumber(range.price_start)}
                      onChange={(e) =>
                        onChangeItem("orderGetProduct", idx, "price_start", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
                <Colxx xxs="6" className="pl-1">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="price_end">
                      đến...
                    </Label>
                    <Input
                      type="text"
                      name="price_end"
                      id="price_end"
                      value={AddCommaNumber(range.price_end)}
                      onChange={(e) =>
                        onChangeItem("orderGetProduct", idx, "price_end", e)
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <div className="position-relative mb-3">
                {range?.ogp_gift?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="product_gift">
                            Sản phẩm tặng
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="ogp_gift"
                            placeholder={
                              <IntlMessages id="discount.select-one-product" />
                            }
                            options={products_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "orderGetProduct",
                                idx,
                                "ogp_gift",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="quantity_ogp_gift">
                            Số lượng
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity_ogp_gift"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "orderGetProduct",
                                idx,
                                "quantity_ogp_gift",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(
                            idx,
                            index,
                            "orderGetProduct",
                            "ogp_gift"
                          )
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() =>
                    onAddProduct(idx, "orderGetProduct", "ogp_gift")
                  }
                />
              </div>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton category="orderGetProduct" onAddItem={onAddItem} />
      </>
    );
  }
  if (selectedOption === "customer-accrual-points-get-product") {
    return (
      <>
        {customerPointGetProduct?.map((range, idx) => {
          return (
            <div key={idx}>
              <div className="position-relative custom-line-dashed mb-4 mt-4">
                <i
                  className="simple-icon-minus absolute-icon cursor-pointer"
                  onClick={() =>
                    onRemoveDiscount(idx, "customerPointGetProduct")
                  }
                />
              </div>
              <Row className="d-flex">
                <Colxx xxs="12">
                  <FormGroup className="has-float-label">
                    <Label className="text-muted" for="customer_point">
                      Mốc điểm tặng
                    </Label>
                    <Input
                      type="text"
                      name="customer_point"
                      id="customer_point"
                      value={AddCommaNumber(range.customer_point)}
                      onChange={(e) =>
                        onChangeItem(
                          "customerPointGetProduct",
                          idx,
                          "customer_point",
                          e
                        )
                      }
                    />
                  </FormGroup>
                </Colxx>
              </Row>
              <div className="position-relative mb-3">
                {range?.cpgp_gift?.map((p, index) => {
                  return (
                    <Row key={index} className="d-flex position-relative">
                      <Colxx xxs="9" className="pr-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label className="text-muted" for="product_gift">
                            Sản phẩm tặng
                          </Label>
                          <Select
                            components={{
                              Input: CustomSelectInput,
                            }}
                            className="react-select pb-1"
                            classNamePrefix="react-select"
                            name="cpgp_gift"
                            placeholder={
                              <IntlMessages id="discount.select-one-product" />
                            }
                            options={products_discount}
                            onChange={(e) =>
                              onChangeItem(
                                "customerPointGetProduct",
                                idx,
                                "cpgp_gift",
                                e,
                                index
                              )
                            }
                            value={p}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="3" className="pl-1">
                        <FormGroup className="mb-1 has-float-label">
                          <Label
                            className="text-muted"
                            for="quantity_cpgp_gift"
                          >
                            Số lượng
                          </Label>
                          <Input
                            bsSize="lg"
                            type="text"
                            inputMode="numeric"
                            name="quantity_cpgp_gift"
                            value={p.quantity}
                            onChange={(e) =>
                              onChangeItem(
                                "customerPointGetProduct",
                                idx,
                                "quantity_cpgp_gift",
                                e,
                                index
                              )
                            }
                            className="py-2"
                          />
                        </FormGroup>
                      </Colxx>
                      <i
                        className="simple-icon-minus absolute-icon-minus-product cursor-pointer"
                        onClick={() =>
                          onRemoveProduct(
                            idx,
                            index,
                            "customerPointGetProduct",
                            "cpgp_gift"
                          )
                        }
                      />
                    </Row>
                  );
                })}
                <i
                  className="simple-icon-plus absolute-icon-plus cursor-pointer"
                  onClick={() =>
                    onAddProduct(idx, "customerPointGetProduct", "cpgp_gift")
                  }
                />
              </div>
            </div>
          );
        })}
        <Separator className="mt-4" />
        <AddMoreButton
          category="customerPointGetProduct"
          onAddItem={onAddItem}
        />
      </>
    );
  }

  // Return null for unhandled cases to prevent React crash
  return null;
};
